import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { DebrisTypeEquipement } from 'app/models/debrisTypeEquipement.model';

@Injectable({
  providedIn: 'root'
})
export class DebrisTypeEquipementService {
private API_URL = environment.API_URL;
  private MODEL_URL = 'debris-types-equipements';

  constructor(private http: HttpClient) { }

  getDebrisTypesEquipements(): Observable<DebrisTypeEquipement[]> {
    return this.http.get<DebrisTypeEquipement[]>(this.API_URL + this.MODEL_URL);
  }

  store(debris_type_equipement: DebrisTypeEquipement): Observable<DebrisTypeEquipement>{
    return this.http.post<DebrisTypeEquipement>(this.API_URL + this.MODEL_URL, debris_type_equipement).pipe(
      catchError(err => throwError(err))
    );
  }
}
